import "slick-carousel";

const option = {
  infinite: false,
  nextArrow: '<button class="c-ico -arrowBlkBorder -next"></button>',
  prevArrow: '<button class="c-ico -arrowBlkBorder -prev"></button>',
  rows: 0,
  slide: "article",
  touchThreshold: 100
};

const setSlider = () => {
  $(".js-slider").each((i, el) => INIT_SLIDER(el));
};

window.INIT_SLIDER = el => {
  if (window.matchMedia("screen and (min-width: 1120px)").matches) {
    const num = $(el).data("num") || 1;

    option.slidesToScroll = num;
    option.slidesToShow = num;

    !$(el).hasClass("slick-initialized") && $(el).slick(option);
  } else {
    $(el).hasClass("slick-initialized") && $(el).slick("unslick");
  }
};

window.addEventListener("load", setSlider);
window.addEventListener("resize", setSlider);
